var CORE_FONT_SIZE = 14;
var CORE_HTML_FONT_SIZE = 16;
var CORE_COEF = CORE_FONT_SIZE / 14;
var pxToRem = function pxToRem(px) {
  return "".concat(px / CORE_HTML_FONT_SIZE * CORE_COEF, "rem");
};
export var CoreTypographyThemeVariants = {
  fontFamily: "'Roboto', sans-serif",
  fontSize: CORE_FONT_SIZE,
  fontWeightBold: 700,
  fontWeightLight: 300,
  fontWeightMedium: 600,
  fontWeightRegular: 400,
  htmlFontSize: CORE_HTML_FONT_SIZE,
  pxToRem: pxToRem,
  body1: {
    fontSize: '1rem' /* 16px */,
    fontWeight: 400,
    letterSpacing: '0.08px',
    lineHeight: '130%' /* 20.8px */
  },
  body2: {
    fontSize: '.875rem' /* 14px */,
    fontWeight: 400,
    letterSpacing: '0.035px',
    lineHeight: '130%' /* 18.2px */
  },
  button: {
    fontSize: '.875rem' /* 14px */,
    fontWeight: 600,
    letterSpacing: '0px',
    lineHeight: '146%' /* 20.44px */,
    textTransform: 'none'
  },
  caption: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.18px',
    lineHeight: '166%' /* 20px */
  },
  h1: {
    fontSize: '3.5rem' /* 56px */,
    fontWeight: 700,
    lineHeight: '150%' /* 84px */,
    letterSpacing: '0.05px'
  },
  h2: {
    fontSize: '2.875rem' /*46px*/,
    fontWeight: 700,
    letterSpacing: '0.46px',
    lineHeight: '150%' /* 69px */
  },
  h3: {
    fontSize: '2.25rem' /* 36px */,
    fontWeight: 700,
    letterSpacing: '0.35px',
    lineHeight: '150%' /* 54px */
  },
  h4: {
    fontSize: '1.75rem' /* 28px */,
    fontWeight: 700,
    letterSpacing: '0.24px',
    lineHeight: '150%' /* 42px */
  },
  h5: {
    fontSize: '1.5rem' /* 24px */,
    fontWeight: 700,
    letterSpacing: '0.16px',
    lineHeight: '130%' /* 31px */
  },
  h6: {
    fontSize: '1.125rem' /* 18px */,
    fontWeight: 700,
    letterSpacing: '0.07px',
    lineHeight: '130%' /* 23.4px */
  },
  overline: {
    fontSize: '.75rem' /* 12px */,
    fontWeight: 600,
    letterSpacing: '0.18px',
    lineHeight: '266%' /* 32px */,
    transform: 'uppercase'
  },
  subtitle1: {
    fontSize: '1rem' /* 16px */,
    fontWeight: 600,
    letterSpacing: '0.024px',
    lineHeight: '130%' /* 20.8px */
  },
  subtitle2: {
    fontSize: '0.875rem' /* 14px */,
    fontWeight: 600,
    letterSpacing: '0.014px',
    lineHeight: '130%' /* 18.2px */
  }
};